const initialState = {
	master: {
        sheetCode: "",
        plant: "",
        mbrNo: "",
        projectNm: "",
        processCd: "",
        unitCd: "",
        description: "",
        cycle: "1",
        revision: 0,
        webContent: ""
    },
	header: {
		inAcceptableRange: "Acceptable Range",
		inReceivingSite: "Receiving Site",
		inSendingSite: "Sending Site",
		inSetPoint: "Set Point",
		inTargetRange: "Target Range",
		outAcceptableRange: "Acceptable Range",
		outReceivingSite: "Receiving Site",
		outSendingSite: "Sending Site",
		outTargetRange: "Target Range",
		qcAcceptanceLimit: "Acceptance Limit",
		qcActionLimit: "Action Limit",
		qcAlertLimit: "Alert Limit",
		qcReceivingSite: "Receiving Site",
		qcSendingSite: "Sending Site"
	},
	sub: [],
	composition: [],
	in: [],
	out: [],
	qc: [],
	level: 0
}

export default function bplCreate(state = initialState, action) {
	if(action.type === "BPLCreate")
	switch (action.action) {
		case "SetMaster": {
			return {...state, master: {...state.master, ...action.data}}
		}
		case "SetStepOperation": {
			return {...state, sub: [...action.data]}
		}
		case `Set${action.paramType}Params`: {
			return {...state, [action.paramType]: [...action.data]}
		}
		case `SetParamData`: {
			return {...state, ...action.data}
		}
		case "initial": return initialState;
		default:
			return state
	} else {
		return state
	}
}